import { numeroPreco } from '../../../../../Utils/promocao';
import { GrupoComplemento, Produto } from './catalogoPreview';

// A gratuidade depende da menor seleção permitida, não de existir uma opção paga.
export function revisarPrecoImportacao(produto: Produto, produtos: Produto[], tipo = produto.tipo) {
  const precos = produto.valores.length ? produto.valores.map(v => v.valor) : [produto.valor];
  const baseZero = precos.some(valor => numeroPreco(valor) === 0);
  const exigePagamento = (grupo: GrupoComplemento) => {
    let faltam = Math.max(1, Number(grupo.sizeMin) || 0);
    let total = 0;
    if (!Number.isInteger(faltam) || (grupo.sizeMax > 0 && grupo.sizeMax < faltam)) return false;
    const opcoes = grupo.itens.map(opcao => ({
      preco: numeroPreco(opcao.price ?? produtos.find(p => p.id === opcao.id)?.valor),
      limite: grupo.permitirRepetir === false ? 1 : opcao.quantidadeMaxima ?? Infinity,
    })).sort((a, b) => a.preco - b.preco);
    if (opcoes.some(o => !Number.isFinite(o.preco) || o.preco < 0 || !(o.limite > 0))) return false;
    for (const opcao of opcoes) {
      const quantidade = Math.min(faltam, opcao.limite);
      total += quantidade * opcao.preco;
      faltam -= quantidade;
      if (!faltam) break;
    }
    return faltam === 0 && total > 0;
  };
  const pagoObrigatorio = produto.grupoComplementos.some(g => g.obrigatoriedade === 'obrigatorio' && exigePagamento(g));
  const podeSerGratuito = tipo !== 'complementos' && baseZero && !pagoObrigatorio;
  const pendente = podeSerGratuito && produto.gratuitoConfirmado !== true;
  const gruposSugeridos = pendente ? produto.grupoComplementos
    .map((grupo, indice) => ({ grupo, indice }))
    .filter(({ grupo }) => grupo.obrigatoriedade === 'opcional' && exigePagamento(grupo)) : [];
  return { pendente, podeSerGratuito, gruposSugeridos };
}
